// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"61c19ba06517ebdaa1c3","126":"02ffd76b06c0b95adea4","127":"6b02a5ed1a8285e2e183","177":"785ae9fbf7a174dc636f"}[chunkId] + ".chunk.js";
};